<template>
  <div class="full-calendar">
    <div class="row">
      <div class="col-lg-6">
        <h2 v-if="cDate && defaultView === 'dayGridMonth'" class="pl-0">{{ cDate | moment('MMMM YYYY') }}</h2>
        <h2 v-if="cDate && defaultView === 'dayGridWeek'" class="pl-0">{{ cDate | moment('MMMM YYYY') }}</h2>
        <h2 v-if="cDate && defaultView === 'timeGridDay'" class="pl-0">{{ cDate | moment('MMMM D, YYYY') }}</h2>
      </div>
      <div class="col-lg-6 pt-1 text-lg-right">
        <a href="#" @click.prevent="prev" class="fullcalendar-btn-prev btn btn-sm btn-default">
          <i class="fas fa-angle-left"></i>
        </a>
        <a href="#" @click.prevent="next" class="fullcalendar-btn-next btn btn-sm btn-default">
          <i class="fas fa-angle-right"></i>
        </a>
        <b-button
          variant="default"
          size="sm"
          :class="{'active': defaultView === 'dayGridMonth'}"
          @click="changeView('dayGridMonth')"
        >
          Month
        </b-button>
        <b-button
          variant="default"
          size="sm"
          :class="{'active': defaultView === 'timeGridWeek'}"
          @click="changeView('timeGridWeek')"
        >
          Week
        </b-button>
        <b-button
          variant="default"
          size="sm"
          :class="{'active': defaultView === 'timeGridDay'}"
          @click="changeView('timeGridDay')"
        >
          Day
        </b-button>
      </div>
    </div>

    <br>

    <full-calendar
      :events="events"
      :plugins="calendarPlugins"
      :editable="true"
      contentHeight="auto"
      :theme="false"
      :selectable="true"
      :selectHelper="true"
      ref="fullCalendar"
      class="calendar"
      :defaultView="defaultView"
      @eventClick="onEventClick"
      @select="onSelect"
      @eventDrop="dateOrTimeChanged"
      @eventResize="dateOrTimeChanged"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  // modules
  import FullCalendar from '@fullcalendar/vue'
  import dayGridPlugin from '@fullcalendar/daygrid'
  import timeGridPlugin from '@fullcalendar/timegrid'
  import interactionPlugin from '@fullcalendar/interaction'
  // services
  import db from '@/services/db'
  // helpers
  import utils from '@/helpers/utils/index.js'

  export default {
    name: 'calendar',
    props: ['calendarId', 'forCurrentUser'],
    components: {
      FullCalendar
    },
    data () {
      return {
        options: null,
        calendarPlugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin
        ],
        defaultView: 'timeGridWeek',
        model: {
          title: '',
          className: 'bg-yellow',
          description: '',
          start: '',
          end: ''
        },
        cDate: null,
        calendarData: null,
        gridOptions: null,
        gridData: null,
        events: []
      };
    },
    computed: {
      ...mapState([
        'currentTab',
        'userId',
        'fbUserModels',
        'fbWorkspaceData',
        'models_dashboardModel'
      ])
    },
    watch: {
      fbUserModels: {
        deep: true,
        handler () {
          this.fillEvents()
        }
      },
      fbWorkspaceData: {
        deep: true,
        handler () {
          this.fillEvents()
        }
      },
      models_dashboardModel: {
        deep: true,
        handler () {
          this.fillEvents()
        }
      },
      currentTab () {
        this.$nextTick(() => {
          this.calendarApi.updateSize()
        })
      },
      calendarApi () {
        this.$refs.fullCalendar.getApi()
      }
    },
    methods: {
      changeView (viewType) {
        this.defaultView = viewType
        this.calendarApi.changeView(viewType)
      },
      next () {
        this.calendarApi.next()
        this.setCalendarDate()
      },
      prev () {
        this.calendarApi.prev()
        this.setCalendarDate()
      },
      setCalendarDate () {
        this.cDate = this.calendarApi.getDate()
      },
      onSelect (data) {
        const { start, end } = data

        this.model.start = start
        this.model.end = end

        this.showAddTaskModal(start, end)
      },
      onEventClick ({ el, event }) {
        $dgShowEditRowForm(this.options.gridId, event.id)
      },
      dateOrTimeChanged ({ el, event }) {
        const tData = this.getGridData()
        const row = tData[event.id]

        row.start.value = Date.parse(event.start)
        if (event.end) row.end.value = Date.parse(event.end)

        db.dataGrid.data.saveRowData(this.gridOptions.gridId, row.rowKey, row)
      },
      showAddTaskModal (start, end) {
        const data = {
          title: '',
          user: null,
          start: Date.parse(start),
          end: Date.parse(end)
        }

        $dgShowAddRowModal(this.options.gridId, data)
      },
      fillEvents () {
        const tData = this.getGridData()

        const events = []

        console.error('GET IT FIX <<<<<<< FULLCALENDAR index.vue')

        // if (tData) {
        //   for (let rowKey in tData) {
        //     const row = tData[rowKey]

        //     let title = row.title.value
        //     const start = row.start.value
        //     const end = row.end.value

        //     if (this.forCurrentUser && row.user.value) {
        //       if (!(~row.user.value.indexOf(this.userId))) continue
        //     }
        //     if (!title || !start) continue

        //     const model = JSON.parse(JSON.stringify(this.model))

        //     if (this.options.compositeTitle) {
        //       const props = this.options.compositeTitle.split(',')
        //       title = ''

        //       for (let prop of props) {
        //         title += `${this.gridOptions.meta[prop].displayName}: ${$getDataGridVal(row[prop])} \n`
        //       }
        //     }

        //     model.title = title
        //     model.start = start
        //     model.end = end
        //     model.id = rowKey

        //     events.push(model)
        //   }
        // }

        this.events = events
      },
      getGridData () {
        const getModel = db.dataGrid.data.getReadModel(this.gridOptions.storageType)
        return getModel(this.gridOptions.source)
      }
    },
    async created () {
      this.options = await db.fullCalendar.getOptions(this.calendarId)
      await new Promise((resolve) => {
        db.dataGrid.options.read(this.options.gridId, (options) => {
          this.gridOptions = options
          resolve()
        })
      })

      this.fillEvents()
    },
    mounted () {
      this.$nextTick(() => {
        if (!this.calendarApi) return
        this.setCalendarDate()
        this.calendarApi.updateSize()
      })
    }
  }
</script>

<style lang="scss">
  @import "@fullcalendar/core/main.css";
  @import '@fullcalendar/daygrid/main.css';
  @import '@fullcalendar/timegrid/main.css';
  @import '@/libs/vue-argon-dashboard-pro-master/src/assets/sass/core/vendors/_fullcalendar.scss';

  .full-calendar {
    overflow-x: hidden;
  }
</style>

